"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var GetStartedMessage = function GetStartedMessage(_ref) {
  var amountMin = _ref.amountMin,
    amountMax = _ref.amountMax,
    _ref$isMarketingMode = _ref.isMarketingMode,
    isMarketingMode = _ref$isMarketingMode === void 0 ? false : _ref$isMarketingMode,
    isMedicalMarket = _ref.isMedicalMarket;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "select-treatment-msg"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "amount-range"
  }, "Plan amounts: ", "".concat(amountMin, " - ").concat(amountMax)));
};
GetStartedMessage.propTypes = {
  amountMin: _propTypes.default.string.isRequired,
  amountMax: _propTypes.default.string.isRequired,
  isMarketingMode: _propTypes.default.bool,
  isMedicalMarket: _propTypes.default.bool
};
var _default = GetStartedMessage;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-payment-calculator-v2/dist/client/components/scss/index.scss');